<div
     style="height:100%; display: flex; align-items: flex-start; justify-content: center; font-size: 16px; padding-top: 45px;">
  <div style="width: 400px; margin-bottom: 145px;">
    <form [formGroup]="resetPasswordFormGroup">
      <div>
        <div style="width: 100%; display: flex; justify-content: center; padding: 15px 0;">
          <img *ngIf="!isDarkMode()" style="width: 217px;" src="/assets/images/lexbe-logo.svg" />
          <img *ngIf="isDarkMode()" style="width: 217px;" src="/assets/images/lexbe-logo-dark-theme-3.svg" />
        </div>
        <div style="padding: 36px 0; text-align: center; font-size: 14px;">
          <div *ngIf="state === 'reset-password'" style=" padding-top: 20px;">Please setup a new password to sign in to
            your account.</div>
          <div *ngIf="state === 'success'" style=" padding-top: 20px;">Password successfully reset! Click <a
               href="/identity/login">here</a> to sign in with your new password.</div>
        </div>
        <div *ngIf="state === 'reset-password'" style="display: flex; flex-direction: column; gap: 13px;">
          <div>
            <mat-form-field class="full-width password gold-outline-1 blue-primary-outline-1 error-outline" appearance="outline">
              <mat-label>New Password</mat-label>
              <input matInput type="password" placeholder="New Password" formControlName="newPassword"
                     autocomplete="none" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-width password gold-outline-1 blue-primary-outline-1 error-outline" appearance="outline">
              <mat-label>Confirm Password</mat-label>
              <input matInput type="password" placeholder="Confirm Password" formControlName="confirmPassword"
                     autocomplete="none" required>
            </mat-form-field>
          </div>
          <lex-manage-password-requirements [newPasswordControl]="resetPasswordFormGroup.get('newPassword')"
                                            [confirmPasswordControl]="resetPasswordFormGroup.get('confirmPassword')"
                                            [(passwordRequirementMet)]="passwordRequirementMet"></lex-manage-password-requirements>
          <div style="padding: 10px 0;">
            <button class="set-password-button" style="width: 100%; height: 45px; border-radius: 3px;" mat-raised-button color="primary"
                    (click)="resetPassword()" [disabled]="!passwordRequirementMet">Set Password</button>
          </div>
        </div>
        <div>
        </div>
      </div>
    </form>
  </div>
</div>